import { getRouteSdkOptions } from '@repo/ssr'
import { createFileRoute } from '@tanstack/react-router'
import { CheckCircle2, CircleAlert } from 'lucide-react'
import { MarketingHeader, PortalFooter } from '@/components/portal-shell'
import { type TKey, translateApp } from '@/lib/i18n'
import { loadStatus } from './-lib/status-loader'

export const Route = createFileRoute('/status')({
	ssr: true,
	loader: (routeContext) => {
		return loadStatus(
			getRouteSdkOptions(routeContext, {
				signal: routeContext.abortController.signal
			})
		)
	},
	component: StatusPage
})

function StatusPage() {
	const status = Route.useLoaderData()
	const { appLanguage } = Route.useRouteContext()
	const t = (key: TKey) => translateApp(appLanguage, key)
	const isHealthy = status === 'healthy'
	return (
		<div className='portal-page min-h-svh'>
			<MarketingHeader appLanguage={appLanguage} />
			<main className='portal-container simple-page py-9 pb-20'>
				<div className='simple-page__intro mb-7 max-w-[42.5rem]'>
					<p className='portal-eyebrow'>
						{t('common:status.eyebrow')}
					</p>
					<h1>
						{isHealthy
							? t('common:status.healthy_title')
							: t('common:status.unavailable_title')}
					</h1>
					<p className='portal-lead'>
						{t('common:status.description')}
					</p>
				</div>
				<section className='status-list grid max-w-[48.75rem] gap-3'>
					<Status isHealthy={isHealthy} t={t} />
				</section>
			</main>
			<PortalFooter appLanguage={appLanguage} />
		</div>
	)
}

function Status(props: { isHealthy: boolean; t: (key: TKey) => string }) {
	return (
		<article className='status-row flex items-center justify-between gap-4 p-[1.0625rem]'>
			<div>
				<h2>{props.t('common:status.infrastructure')}</h2>
				<p>{props.t('common:status.availability_check')}</p>
			</div>
			<span
				className={
					props.isHealthy
						? 'status-pill status-pill--ok'
						: 'status-pill status-pill--warning'
				}
			>
				{props.isHealthy ? (
					<CheckCircle2 aria-hidden='true' />
				) : (
					<CircleAlert aria-hidden='true' />
				)}{' '}
				{props.isHealthy
					? props.t('common:status.operational')
					: props.t('common:status.unavailable')}
			</span>
		</article>
	)
}
